<template>
    <main id="profile-wrapper">
        <div id="profile-page" class="pb-5">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url+'/', status: false },
                    { title: 'HCID', url: app_url+'/hcid', status: false },
                    { title: 'Profile', url: app_url+'/profile', status: true }
                ]"
            ></breadcrumb>
            <ModalQR :cardNumber="qr.cardNumber" :size="qr.size" level="H"></ModalQR>
            <div class="container-fluid title-row">
                <div class="container py-5">
                    <div class="row">
                        <div class="col">
                            <h2 class="title">Profil</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container my-4">
                <div class="row justify-content-center">
                    <div class="col-md-12">
                        <div class="row pb-3">
                            <div class="col-md-4 py-3">
                                <div class="card text-center">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col">
                                                <a class="profile-image" :style="{ backgroundImage: 'url(' + avatar + ')' }">
                                                    <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-success="uploadedCompleted"></vue-dropzone>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="row row-name pt-3">
                                            <div class="col">
                                                <span>{{user.name}}</span>
                                            </div>
                                        </div>
                                        <div class="row row-club py-2">
                                            <div class="col">
                                                <span>{{user.club}}</span>
                                            </div>
                                        </div>
                                        <div class="row py-2">
                                            <div class="col">
                                                <a :href="app_url+'/profile/edit'" class="btn btn-edit d-inline">Edit Profil</a>
                                                <a data-toggle="modal" data-target="#modalVirtualCard" class="btn btn-view d-inline"><i class="fa fa-qrcode fa-lg pr-2"></i>Lihat Virtual Card</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col py-3">
                                <div class="card">
                                    <div v-if="loadersocmed" class="loading loading-double"></div>
                                    <div v-else class="card-body">
                                        <div class="row row-name pb-4">
                                            <div class="col text-left">
                                                <span>Koneksikan Akun Kamu </span>
                                            </div>
                                        </div>
                                        <div class="row py-2">
                                            <div id="icon-google" class="text-center">
                                                <img class="img-button" :src="base_url+'/images/google.svg'" alt="google-img">
                                            </div>
                                            <div class="col-md-7">
                                                <a v-if="socmedstatus.google == 1" href="#" class="btn btn-google d-flex-inline py-2">Sudah Terhubung Google</a>
                                                <a v-else @click="connectSocmed('google')" class="btn btn-google d-flex-inline py-2">Sambungkan ke Google</a>
                                            </div>
                                        </div>
                                        <div class="row py-2">
                                            <div id="icon-facebook" class="text-center">
                                                <img class="img-button" :src="base_url+'/images/facebook.svg'" alt="facebook-img">
                                            </div>
                                            <div class="col-md-7">
                                                <a v-if="socmedstatus.facebbok === 1" href="#" class="btn btn-facebook d-flex-inline py-2">Sudah Terhubung Facebook  </a>
                                                <a v-else @click="connectSocmed('facebook')" class="btn btn-facebook d-flex-inline py-2">Sambungkan ke Facebook </a>
                                            </div>
                                        </div>
                                        <div class="row py-2">
                                            <div id="icon-twitter" class="text-center">
                                                <img class="img-button" :src="base_url+'/images/twitter.svg'" alt="twitter-img">
                                            </div>
                                            <div class="col-md-7">
                                                <a  v-if="socmedstatus.twitter == 1" href="#" class="btn btn-twitter d-flex-inline py-2">Sudah Terhubung Twitter</a>
                                                <a  v-else @click="connectSocmed('twitter')" class="btn btn-twitter d-flex-inline py-2">Sambungkan ke Twitter</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import ModalQR from "../../widget/ModalQR";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    components: {
        breadcrumb: BreadCrumb,
        ModalQR,
        vueDropzone: vue2Dropzone
    },
    data() {
        return {
            base_url:'',
            app_url:'',
            api_url:'',
            qr: {
                cardNumber: 'HCID00099777',
                size: 247,
            },
            mobile: false,
            user:null,
            token:null,
            avatar:base_url+'/images/default-avatar.png',
            image:'',
            socmedstatus:'',
            facebbok:'',
            loadersocmed:true,
            socmed_token:'',
            tokenForm: new Form({
                token:'',
                provider:'',
            }),
            avatarForm: new Form({
                file:'',
            }),
            dropzoneOptions: {
                url: api_url+'/member/update_foto',
                thumbnailWidth: 150,
                maxFilesize: 1,
                headers: null,
                acceptedFiles: ".jpeg,.jpg,.png,.gif",
            }
        };
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        if(localStorage.getItem('user') != null){
            this.user = JSON.parse(localStorage.getItem('user'));
            this.avatar = this.user.avatar;
        }
        if(localStorage.getItem('token') != null){
            this.token = localStorage.getItem('token');
            this.dropzoneOptions.headers = {
                      'Authorization':  `Bearer ${this.token}`,
                      }
        }
        if(localStorage.getItem('provider') != null && localStorage.getItem('socmed_token') != null){
            if(localStorage.getItem('socmed_token') != 'false'){
                this.tokenForm.provider = localStorage.getItem('provider');
                this.socmed_token = localStorage.getItem('socmed_token');
                this.tokenForm.token = this.socmed_token;
                this.updateSocmed();
            }
        }
        this.getSocmedStatus();
    },
    methods: {
        connectSocmed(provider){
            localStorage.setItem('provider',provider);
            window.location.href = api_url+'/auth/social/'+provider;
        },
        getSocmedStatus() {
            this.loadersocmed = true;
            axios.get(this.api_url+'/member/status_social',{
                    headers: {
                        'Authorization': `Bearer ${this.token}`
                    }
                })
                .then(response => {
                    this.socmedstatus = response.data.data;
                    this.loadersocmed = false;
                    this.facebbok = response.data.data.facebbok;
                }).catch(error => {
                    console.log(error);
                });
        },
        updateSocmed() {
            this.tokenForm.post(api_url+"/member/update_social")
            .then((response) => {
                console.log(response);
            })
            .catch((response) => {
                console.log("ERROR");
            });
        },
        uploadedCompleted(file,response) {
                localStorage.setItem('user',JSON.stringify(response.data))
                this.avatar = response.data.avatar;
        },
    }
};
</script>

<style scoped lang="scss">
body{
    background: #000000;
}
#profile-page{
    background: #000000;
    .card{
        background: #191919;
        border-radius: 10px;
        color: #FFFFFF;
    }
    .title-row{
        background: #191919;
        opacity: 0.95;
        color: #FFFFFF;
    }
    .title{
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        line-height: 42px;
    }
    .profile-img{
        width: 100%;
    }
    .profile-image{
        cursor: pointer;
        position: relative;
        overflow: hidden;
        border-radius:50%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        width: 100px; height: 100px;
        display: block;
        margin:0 auto;
    }
    .profile-image:before{
        content:'Change Photo';
        position: absolute;
        width: 100%; height: 100%;
        left: 0; top: 100%;
        background-color: rgba(0,0,0,0.5);
        color:#fff;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
    }
    #dropzone{
        position: absolute;
        top: 100%;
        left: 0;
        min-height:100px;
        width: 100%;
        padding:0;
        border:none;
      .dz-preview{
        margin:0;
        }
    }
    .dropzone .dz-preview{
        margin:0;
    }
    .profile-image:hover{
        #dropzone{
            top:0;
        }
    }
    .row-name{
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
        color: #FFFFFF;
    }
    .row-club{
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 28px;
        text-align: center;
        color: #B4B4B4;
    }
    .btn-edit{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #FFFFFF;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0px 10px;
        height: 28px;
        left: 159px;
        top: 733px;
        border: 1px solid #686868;
        box-sizing: border-box;
        border-radius: 10px;
    }
    .btn-view{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #FFFFFF;
        flex: none;
        order: 1;
        flex-grow: 0;
        margin: 0px 10px;
        background: #E61B33;
        border-radius: 10px;
        height: 28px;
    }
    .btn-google{
        background: #252525;
        border-radius: 5px;
        color: #FFFFFF;
        width: 100%;
        height: 45px;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
    }
    .btn:hover{
        color: #FFFFFF;
    }
    .fa{
        color: #FFFFFF;
    }
    .img-button{
        background: #FFFFFF;
        border-radius: 5px;
    }
    #icon-twitter{
        position: absolute;
        left: 25px;
        bottom: 35px;
        z-index: 1;
        background-color:white;
        border-radius: 5px;
        width: 30px;
        height: 30px;
    }
    #icon-facebook{
        position: absolute;
        left: 25px;
        bottom: 97px;
        z-index: 1;
        background-color:white;
        border-radius: 5px;
        width: 30px;
        height: 30px;
    }
    #icon-google{
        position: absolute;
        left: 25px;
        top: 90px;
        z-index: 1;
        background-color:white;
        border-radius: 5px;
        width: 30px;
        height: 30px;
    }
    .btn-facebook{
        background: #3B5998;
        border-radius: 5px;
        color: #FFFFFF;
        width: 100%;
        height: 45px;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
    }
    .btn-twitter{
        background: #1DA1F2;
        border-radius: 5px;
        color: #FFFFFF;
        width: 100%;
        height: 45px;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
    }
    .modal-content{
        background: #FFFFFF;
        border-radius: 10px;
    }
    .modal-header{
        border-bottom:unset;
    }
    .modal-title{
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #E61B33;
    }
    #card-img{
        max-height: 124px;
    }
    #card-id{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 25px;
        text-align: center;
        color: #282828;
    }
    #card-label{
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        color: #B4B4B4;
    }
    @media (max-width: 768px) {
    }
}
</style>
